import { isEmpty, map } from 'lodash-es';

import { Pool } from '@dev/ee-api/ee-api-models';
import { SimplePopoverPlainOption } from '@dev/ee-components';

export const useIPpoolsArray = (ipPools: Pool[]): SimplePopoverPlainOption[] => {
    if (isEmpty(ipPools)) {
        return [];
    }
    return map(ipPools, (ipPool) => {
        const label =
            ipPool.Description === '' || ipPool.Description === 'Default'
                ? ipPool.Name
                : `${ipPool.Name} | ${ipPool.Description}`;
        return { label, value: ipPool.Name, count: ipPool.IP.length };
    });
};
